import styled, { css } from 'styled-components';

interface CommonButtonPropsType {
  onClick: () => void;
  isSelected: boolean;
  title: string;
  size: 'sm' | 'lg';
}

const CommonButton = ({ onClick, isSelected, title, size }: CommonButtonPropsType) => {
  return (
    <Button type="button" onClick={onClick} isSelected={isSelected} size={size}>
      {title}
    </Button>
  );
};

export default CommonButton;

// ======================= styled-components =======================

const Button = styled.button<{ isSelected: boolean; size: 'sm' | 'lg' }>`
  border: none;
  border-radius: 16px; /* rounded-2xl */
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  font-size: 14px; /* text-sm */
  line-height: 21px; /* leading-[21px] */

  @media (min-width: 640px) {
    font-size: 18px; /* text-lg */
    line-height: 27px; /* leading-[27px] */
  }

  ${({ size }) =>
    size === 'sm'
      ? css`
          padding: 10.5px 12px;

          @media (min-width: 640px) {
            padding: 13.5px 12px;
          }
        `
      : css`
          padding: 25.5px 0;
          width: 50%;

          @media (min-width: 640px) {
            padding-top: 28px;
            padding-bottom: 27px;
            padding-left: 40px;
            padding-right: 40px;
          }
        `}

  ${({ isSelected }) =>
    isSelected
      ? css`
          background-color: #0b46dd; /* bg-blue-200 */
          color: white;
          font-weight: bold;
        `
      : css`
          background-color: #f5f5f5; /* bg-gray-100 */
          color: #7d7e81; /* text-gray-200 */
          font-weight: 300; /* font-light */
        `}
`;
